export const getLoggedinUser = (): any => {
    try { return JSON.parse(sessionStorage.getItem('authUser') || 'null'); } catch { return null; }
};
let authorizationOverride: string | null | undefined;
export const setAuthorization = (token?: string | null) => { authorizationOverride = token || null; };
export const getAuthorization = () => {
    const token = authorizationOverride === undefined ? getLoggedinUser()?.token : authorizationOverride;
    return token ? `Bearer ${token}` : undefined;
};
export const updateLoggedinUser = (payload: Record<string, any>) => {
    const current = getLoggedinUser();
    if (!current) return null;
    const updated = { ...current, ...payload };
    sessionStorage.setItem('authUser', JSON.stringify(updated));
    return updated;
};
export const isTokenTopUpCancelled = (error: unknown): boolean => Boolean(
    error && typeof error === 'object' && (error as any).isInsufficientTokensCancelled === true
);
